/* import __COLOCATED_TEMPLATE__ from './take-first-steps.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */
import templateOnlyComponent from '@ember/component/template-only';

interface Signature {
  Element: HTMLDivElement;
  Args: {
    shouldShowPersonalized: boolean;
    setUpFinClick: (section: string) => void;
  };
}

const TakeFirstSteps = templateOnlyComponent<Signature>();
export default TakeFirstSteps;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Reporting::Automation::AiInsights::FinReadiness::TakeFirstSteps': typeof TakeFirstSteps;
    'reporting/automation/ai-insights/fin-readiness/take-first-steps': typeof TakeFirstSteps;
  }
}
